export interface Disposable {
    dispose(): void
}

export type DisposableEntity<T> = T & Disposable;

export function isDisposable(item: any): item is Disposable {
    return _.isObject(item) && _.isFunction(item.dispose);
}